import { coreApiAuthedClient, coreApiClient } from '@/src/shared/api/clients';
import { toApiError } from '@/src/shared/api/accounts/http';
import type { InvitationLookupResponse } from './dto';

const BASE = '/v1/households/invitations';

// Both calls run in the browser: the API rate-limits them per client IP, and the
// Next server does not forward that IP.
// Without a session the public client skips asking the Next server for a token it
// does not have, which would only answer 401.
export async function lookupInvitation(
  token: string,
  { withSession = true }: { withSession?: boolean } = {},
): Promise<InvitationLookupResponse> {
  const client = withSession ? coreApiAuthedClient : coreApiClient;
  try {
    const res = await client.POST<{ token: string }, InvitationLookupResponse>({
      path: `${BASE}/lookup`,
      data: { token },
    });
    return res.data;
  } catch (err) {
    toApiError(err);
  }
}

export async function acceptInvitation(token: string): Promise<void> {
  try {
    await coreApiAuthedClient.POST<{ token: string }, unknown>({
      path: `${BASE}/accept`,
      data: { token },
    });
  } catch (err) {
    toApiError(err);
  }
}
